import React, { useState } from 'react';
import '../Css/header-footer.css';
import { NavLink, useLocation } from 'react-router-dom';
import { useLanguage } from "../context/LanguageContext";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { lang, setLang } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = lang === "ar" ? "en" : "ar";
    setLang(newLang);
    localStorage.setItem("lang", newLang);
    i18n.changeLanguage(newLang);
    document.body.dir = newLang === "ar" ? "rtl" : "ltr";
  };

  React.useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header dir={lang === "ar" ? "rtl" : "ltr"}>
      <nav className="custom-navbar container">
        <NavLink className="navbar-brand" to="/">
          <img src={require('../images/AETHERIS-removebg-preview.png')} alt="logo" />
        </NavLink>

        {/* Toggle button for mobile */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>

        {/* Links */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><NavLink to="/">{t("home")}</NavLink></li>
          <li><NavLink to="/about">{t("about")}</NavLink></li>
          <li><NavLink to="/services">{t("services")}</NavLink></li>
          <li><NavLink to="/stories">{t("stories")}</NavLink></li>
          <li><NavLink to="/contact-us">{t("contact")}</NavLink></li>
          <li>
            <button className="lang-switch-btn" onClick={toggleLanguage}>
              <img
                src={lang === "ar"
                  ? require("../images/download.png")    
                  : require("../images/downloadar.png")  
                }
                alt="Language Flag"
              />

              <span>{lang === "ar" ? "En" : "AR"}</span>
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
